export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const

export const USER_ACTIONS = {
  SUSPEND: 'suspended',
  BLOCK: 'block',
  BANNED: 'banned',
  UNSUSPEND: 'unsuspend',
} as const

export const USER_ACTIVITY = {
  page: 1,
  limit: 5,
}

export const PROTECTED_ROLES = {
  SUPER_ADMIN: 'super_admin',
  SLOPESYNC_ADMIN: 'SlopeSync Admin',
} as const

export const PROTECTION_MESSAGES = {
  SELF_ACTION: 'You cannot perform this action on your own account',
  SUPER_ADMIN_PROTECTION: 'SlopeSync Admins cannot be blocked or suspended',
  INSUFFICIENT_PERMISSIONS:
    "You don't have permission to perform this action on this user",
} as const

export const DATATYPE = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  NONE: '',
}

export const CATEGORY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const USER_ROLES = {
  attendee: 'attendee',
  eventAdmin: 'event_admin',
  superAdmin: 'super_admin',
  sponsor: 'sponsor',
}

export const ROUTE_PATTERNS = {
  PARAM_PLACEHOLDER: /:[^/]+/g,
  PARAM_MATCHER: '[^/]+',
} as const

export const USER_STATUSES = {
  active: 'active',
  banned: 'banned',
}

export const PAYMENT_STATUS = {
  COMPLETED: 'completed',
  COMPLETED_MANUALLY: 'completed_manually',
  PENDING: 'pending',
  REFUNDED: 'refunded',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  UNPAID: 'unpaid',
} as const

export const REFUND_PERCENTAGES = [
  { value: 25, label: '25% Refund' },
  { value: 50, label: '50% Refund' },
  { value: 75, label: '75% Refund' },
  { value: 100, label: '100% Refund' },
] as const

export const DEFAULT_REFUND_PERCENTAGE = 25

export const DASHBOARD_DATA_FETCH_TIMEOUT = 10000

export const STATISTICS_DATA_FETCH_TIMEOUT = 300000

export const SEARCH_DEBOUNCE_TIMEOUT = 500

export const months = [
  { value: '1', label: 'January' },
  { value: '2', label: 'February' },
  { value: '3', label: 'March' },
  { value: '4', label: 'April' },
  { value: '5', label: 'May' },
  { value: '6', label: 'June' },
  { value: '7', label: 'July' },
  { value: '8', label: 'August' },
  { value: '9', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
]

export const SORTING = {
  ASC: 'asc' as const,
  DESC: 'desc' as const,
}

export const MAX_TICKETS_LIMIT = 9
export const MAX_PACKAGES_LIMIT = 4
export const MAX_EVENT_HIGHLIGHTS_LIMIT = 5

export const contactUSEmail = 'support@blackpowderfestival.com'

export const SURROUNDING_P_REGEX = /^(<p>|<\/p>)$/g
export const NBSP_REGEX = /&nbsp;/g
export const BR_REGEX = /<br\s*\/?>/g
